import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const importsAnalytics = new AnalyticsService("Imports");

export const importAddAnalytics = importsAnalytics.extend("Add Import");

export default importsAnalytics;
